<div style="colorScheme: 'none'">
<div id="paypalCheckout" #paypalCheckout></div>
</div>